/* eslint-disable parog-web/no-glint-expect-error-directive */
import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type { IntlService } from 'ember-intl';
import not from 'ember-truth-helpers/helpers/not';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import OnlineConsultationReportWrittenJournalEvent from 'parog-web/models/online-consultation-report-written-journal-event';

export default class ReportEditionFormComponent extends CrudJournalEventBaseComponent {
  static override fullComponentId = 'online-consultation/report-edition-form';
  static override journalEventClass =
    OnlineConsultationReportWrittenJournalEvent;

  @service declare intl: IntlService;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;
  override shouldAutoSaveDraft = true;

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  <template>
    {{!-- prettier-ignore --}}
    <Provider
      @forcComponent={{this}}
{{! @glint-expect-error }}
      @title={{unless @displayedFromPane 'Rapport de télé-consultation'}}
{{! @glint-expect-error }}
      @isHeaderHidden={{@displayedFromPane}}
{{! @glint-expect-error }}
      @background={{if @displayedFromPane 'transparent'}}
    >
      <:content as |Form|>
        <div class='field'>
          <Form.TextArea
            @labelName='Rapport de la télé-consultation'
            @propertyName='body'
          />
        </div>
        <div class='field'>
          <Form.Date @labelName='Date' @propertyName='occurredAt' />
        </div>
      </:content>
      <:footer as |Footer|>

{{! @glint-expect-error }}
        {{#if @displayedFromPane}}
{{! @glint-expect-error }}
          <div class="[&_button:last-child]:mt-2"  data-tooltip={{unless @isConsultationFinished "Vous pourrez sauvegarder une fois la télé-consultation terminée"}}>

{{! @glint-expect-error }}
        <Footer.SubmitButton @disabled={{not @isConsultationFinished}} />

{{! @glint-expect-error }}
        {{#if @isConsultationFinished}}
          <Footer.CancelButton @title="Quitter" />
        {{/if}}
      </div>
        {{else}}
          <Footer.CancelButton /><Footer.SubmitButton />
        {{/if}}
      </:footer>
    </Provider>
  </template>
}
